export type UpdateComponentProjectResponse = {};
